import { render, staticRenderFns } from "./detailsStepTemplate.vue?vue&type=template&id=24cc1d16"
import script from "./detailsStepTemplate.vue?vue&type=script&lang=js"
export * from "./detailsStepTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports